import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@bingads-webui-react/primitive';
import { I18nContext } from '@bingads-webui-react/i18n-context';


export function RecentReportTitle({ id }) {
  const i18n = useContext(I18nContext);

  return (
    <MenuItem header id={id}>
      {i18n.getString(_TL_('Your recent reports'))}
    </MenuItem>
  );
}

RecentReportTitle.propTypes = {
  id: PropTypes.string,
};

RecentReportTitle.defaultProps = {
  id: undefined,
};
